import { render, staticRenderFns } from "./SCardClientComp.vue?vue&type=template&id=cecd74fc&"
import script from "./SCardClientComp.vue?vue&type=script&lang=js&"
export * from "./SCardClientComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports